// ============================================================
// pdfiumEngine.js — نسخه نهایی
// ============================================================
import { init } from '@embedpdf/pdfium';

let pdfiumInstance = null;
let initPromise = null;

export async function getPdfium() {
  if (pdfiumInstance) return pdfiumInstance;
  if (initPromise) return initPromise;

  initPromise = (async () => {
    try {
      const response = await fetch('/pdfium.wasm');
      if (!response.ok) {
        throw new Error(`خطا در بارگذاری pdfium.wasm (کد ${response.status})`);
      }
      const wasmBinary = await response.arrayBuffer();

      const magic = new Uint8Array(wasmBinary.slice(0, 4));
      if (magic[0] !== 0x00 || magic[1] !== 0x61 || magic[2] !== 0x73 || magic[3] !== 0x6d) {
        throw new Error('pdfium.wasm معتبر نیست. فایل از node_modules کپی نشده.');
      }

      pdfiumInstance = await init({ wasmBinary });
      pdfiumInstance.PDFiumExt_Init();

      console.log('✅ PDFium WASM راه‌اندازی شد');
      return pdfiumInstance;
    } catch (err) {
      initPromise = null;
      console.error('❌ خطا در PDFium:', err);
      throw err;
    }
  })();

  return initPromise;
}

export async function loadPdfFromMemory(pdfData) {
  const pdfium = await getPdfium();

  if (
    pdfData.length < 5 ||
    pdfData[0] !== 0x25 || pdfData[1] !== 0x50 ||
    pdfData[2] !== 0x44 || pdfData[3] !== 0x46 || pdfData[4] !== 0x2d
  ) {
    throw new Error('داده PDF نیست. npm run encrypt-workbooks را اجرا کن.');
  }

  const filePtr = pdfium.pdfium.wasmExports.malloc(pdfData.length);
  pdfium.pdfium.HEAPU8.set(pdfData, filePtr);

  const docPtr = pdfium.FPDF_LoadMemDocument(filePtr, pdfData.length, 0);

  if (!docPtr) {
    const error = pdfium.FPDF_GetLastError();
    pdfium.pdfium.wasmExports.free(filePtr);
    throw new Error(`خطای PDFium (کد ${error})`);
  }

  const pageCount = pdfium.FPDF_GetPageCount(docPtr);

  const pageSizes = [];
  for (let i = 0; i < pageCount; i++) {
    const page = pdfium.FPDF_LoadPage(docPtr, i);
    if (page) {
      pageSizes.push({
        width: pdfium.FPDF_GetPageWidth(page),
        height: pdfium.FPDF_GetPageHeight(page),
      });
      pdfium.FPDF_ClosePage(page);
    } else {
      pageSizes.push({ width: 595, height: 842 });
    }
  }

  return {
    pageCount,
    pageSizes,

    renderPage: async (pageIndex, scale, canvas) => {
      console.log('🚀 renderPage:', pageIndex, 'scale:', scale);

      const page = pdfium.FPDF_LoadPage(docPtr, pageIndex);
      if (!page) throw new Error(`صفحه ${pageIndex + 1} بارگذاری نشد`);

      let bitmapPtr = 0;

      try {
        const pageWidth = pdfium.FPDF_GetPageWidth(page);
        const pageHeight = pdfium.FPDF_GetPageHeight(page);

        const displayWidth = Math.max(1, Math.round(pageWidth * scale));
        const displayHeight = Math.max(1, Math.round(pageHeight * scale));
        // DPR واقعی دستگاه (بدون کپ پایین)
const rawDpr = window.devicePixelRatio || 1;

// سقف بالاتر برای شارپ بودن روی دستگاه‌های Retina
const dpr = Math.min(Math.max(rawDpr, 2), 4);

        const bitmapWidth = Math.round(displayWidth * dpr);
        const bitmapHeight = Math.round(displayHeight * dpr);

        canvas.width = bitmapWidth;
        canvas.height = bitmapHeight;
        canvas.style.width = displayWidth + 'px';
        canvas.style.height = displayHeight + 'px';

        const ctx = canvas.getContext('2d', { alpha: false });

        // ★ alpha = 1 برای BGRA کامل
        bitmapPtr = pdfium.FPDFBitmap_Create(bitmapWidth, bitmapHeight, 1);
        if (!bitmapPtr) throw new Error('bitmap ساخته نشد');

        // پس‌زمینه سفید
        pdfium.FPDFBitmap_FillRect(
          bitmapPtr, 0, 0, bitmapWidth, bitmapHeight, 0xFFFFFFFF
        );

// 0x01 = FPDF_ANNOT
// 0x02 = FPDF_LCD_TEXT ← برای متن شارپ‌تر روی نمایشگرهای LCD
pdfium.FPDF_RenderPageBitmap(
  bitmapPtr, page, 0, 0, bitmapWidth, bitmapHeight, 0, 0x01 | 0x02
);

        console.log('✅ رندر شد');

        const bufferPtr = pdfium.FPDFBitmap_GetBuffer(bitmapPtr);
        const stride = pdfium.FPDFBitmap_GetStride(bitmapPtr);
        const heap = pdfium.pdfium.HEAPU8;

        // شمارش بایت‌های غیرسفید برای تست
        let nonWhite = 0;
        const sampleSize = Math.min(5000, bitmapWidth * bitmapHeight * 4);
        for (let i = 0; i < sampleSize; i++) {
          const b = heap[bufferPtr + i];
          if (b !== 0 && b !== 255) nonWhite++;
        }
        console.log('🔍 nonWhite:', nonWhite, '/', sampleSize);

        // کپی با تبدیل BGRA → RGBA
        const imageData = ctx.createImageData(bitmapWidth, bitmapHeight);
        const dst = imageData.data;
        const rowBytes = bitmapWidth * 4;

        if (stride === rowBytes) {
          // مسیر سریع: تبدیل 32-bit
          const src32 = new Uint32Array(heap.buffer, bufferPtr, bitmapWidth * bitmapHeight);
          const dst32 = new Uint32Array(imageData.data.buffer);
          for (let i = 0; i < src32.length; i++) {
            const v = src32[i];
            dst32[i] = (v & 0xFF00FF00) | ((v & 0x00FF0000) >> 16) | ((v & 0x000000FF) << 16);
          }
        } else {
          for (let y = 0; y < bitmapHeight; y++) {
            const srcRow = bufferPtr + y * stride;
            const dstRow = y * rowBytes;
            for (let x = 0; x < bitmapWidth; x++) {
              const s = srcRow + x * 4;
              const d = dstRow + x * 4;
              dst[d]     = heap[s + 2];
              dst[d + 1] = heap[s + 1];
              dst[d + 2] = heap[s];
              dst[d + 3] = 255;
            }
          }
        }

        ctx.putImageData(imageData, 0, 0);
        console.log('✅ putImageData انجام شد');
      } finally {
        if (bitmapPtr) { try { pdfium.FPDFBitmap_Destroy(bitmapPtr); } catch {} }
        pdfium.FPDF_ClosePage(page);
      }
    },

    close: () => {
      try {
        pdfium.FPDF_CloseDocument(docPtr);
        pdfium.pdfium.wasmExports.free(filePtr);
      } catch {}
    },
  };
}